var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "setting",
    transform: "translate(1.5 1.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5351",
    "data-name": "Group 5351",
    transform: "translate(-1472 -41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    transform: "translate(1472 41)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 18.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "setting-svgrepo-com",
    d: "M85.952,64a.643.643,0,0,1,.612.446l.707,2.2a6.99,6.99,0,0,1,.852.492l2.258-.486a.643.643,0,0,1,.692.309l1.782,3.084a.643.643,0,0,1-.081.753l-1.549,1.71a7.177,7.177,0,0,1,0,.985L92.774,75.2a.643.643,0,0,1,.081.753l-1.782,3.086a.643.643,0,0,1-.692.307l-2.258-.486a7.146,7.146,0,0,1-.851.492l-.708,2.2a.643.643,0,0,1-.612.446H82.388a.643.643,0,0,1-.612-.446l-.706-2.2a7.066,7.066,0,0,1-.855-.495l-2.256.487a.643.643,0,0,1-.692-.309l-1.782-3.084a.643.643,0,0,1,.081-.753l1.549-1.713a7.175,7.175,0,0,1,0-.982L75.566,70.8a.643.643,0,0,1-.081-.753l1.782-3.086a.643.643,0,0,1,.692-.307l2.256.487a7.141,7.141,0,0,1,.855-.5l.707-2.2A.643.643,0,0,1,82.387,64h3.564Zm-.471,1.286H82.858l-.73,2.272-.492.24a5.908,5.908,0,0,0-.7.4l-.455.309-2.335-.5-1.311,2.273,1.6,1.772L78.4,72.6a5.887,5.887,0,0,0,0,.807l.039.545-1.6,1.772,1.313,2.273,2.335-.5.455.307a5.908,5.908,0,0,0,.7.4l.492.24.732,2.272h2.625l.733-2.273.491-.239a5.791,5.791,0,0,0,.7-.4l.454-.307,2.336.5,1.311-2.273-1.6-1.772.039-.545a5.889,5.889,0,0,0,0-.809l-.039-.545,1.6-1.77L90.2,68.006l-2.336.5-.454-.306a5.777,5.777,0,0,0-.7-.4l-.491-.239-.734-2.273ZM84.17,69.143A3.857,3.857,0,1,1,80.313,73,3.857,3.857,0,0,1,84.17,69.143Zm0,1.286A2.571,2.571,0,1,0,86.741,73,2.571,2.571,0,0,0,84.17,70.429Z",
    transform: "translate(1405.33 -14.5)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSetting);
export default __webpack_public_path__ + "static/media/icon-setting.c57104155da5ee22412820f96afd86d7.svg";
export { ForwardRef as ReactComponent };